import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { ACCOUNT_UI as UI } from "@/data/accountI18n";
import { logWarn } from "@/lib/log";

// Landing after Google OAuth ({origin}/#session_id=…): exchange the one-time id on the backend, then go home.
export const AuthCallback = () => {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { loginWithGoogle } = useAuth();
  const { tc } = useLang();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    loginWithGoogle(sessionId)
      .then(() => navigate("/", { replace: true }))
      .catch((e) => { logWarn("google session exchange failed:", e); toast.error(tc(UI.googleFailed)); navigate("/auth", { replace: true }); });
  }, [hash, loginWithGoogle, navigate, tc]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background" data-testid="auth-callback">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <p className="text-sm text-muted-foreground">{tc(UI.googleSigningIn)}</p>
    </div>
  );
};
